import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EncrDecrService } from '@mysrc/app/Providers/EncrDecrService';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommonService } from '../../question/services/commonservice';
import { questionLanguageSetting } from '../models/questionLanguageSetting.model';
import { language } from '../models/language.model';
import { BaseHttpReqRespService } from '@mysrc/app/modules/fwcore/services/base-http-req-resp.service';
import { API_ENDPOINTS } from '@mysrc/app/api-endpoints';

@Injectable()
export class SectionService extends BaseHttpReqRespService {
  myAppUrl: any;

  constructor(
    http: HttpClient,
    @Inject(OKTA_AUTH) private oauth: OktaAuth,
    private EncrDecr: EncrDecrService,
    private commonService: CommonService,
    @Inject('CONFIG_SETTINGS') configSettings: any
  ) {
    super(http, oauth);
    const genSettings = configSettings[<any>'general'];
    this.baseUrl = genSettings[<any>'adminApiUrl'];
    this.apiKey = genSettings[<any>'apiKey'];
    this.myAppUrl = this.baseUrl;
  }

  getSectionList(workspaceId: string): Observable<any[]> {
    debugger;
    return this.commonService.httpGet(
      "", `${this.myAppUrl}/SurveySection/GetSectionList/?workSpaceId=${workspaceId}`
    );
  }

  getSectionDetails(sectionId: number): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    const body = { sectionId };
  
    // Send sectionId as JSON body
    return this.http.post(this.myAppUrl + '/SurveySection/EditSection', body, httpOptions);
  }

  saveSection(sectionForm: any, userId: string, workspaceId: string): Observable<any> {
    debugger;
    const url = `${this.myAppUrl}/SurveySection/SaveSection/`;
    const body = {
      section: {
        sectionId: sectionForm.sectionId ?? 0,
        sectionName: sectionForm.sectionName,
        sectionDescription: sectionForm.sectionDescription,
        confirmation: sectionForm.confirmation,
        AcceptedText: sectionForm.AcceptedText,
        NotAcceptedText: sectionForm.NotAcceptedText,
        isAgree: sectionForm.isAgree,
        isDisagree: sectionForm.isDisagree,
        createdDate: sectionForm.createdDate ?? "",
        createdBy: sectionForm.createdBy ?? "",
        ModifiedDate: sectionForm.ModifiedDate ?? "",
        ModifiedBy: sectionForm.ModifiedBy ?? ""
      },
      userId: userId,
      workspaceId: workspaceId
    };
    console.log('Payload:', body); // Debug log
    return this.http.post<any>(url, body, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  deleteSection(sectionId: string, workspaceId: string): Observable<any> {
    //const param = `?sectionId=${sectionId}&workSpaceid=${workspaceId}`;
    const url = `${this.myAppUrl}SurveySection/DeleteSectionItem/`;
    const body = {
      sectionId,
      workspaceId
    }
    return this.http.post<any>(url, body, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });

    //return this.commonService.httpPost("", this.myAppUrl + 'SurveySection/DeleteSectionItem' + param, httpOptions);
  }

  // Language-related methods
  getLanguageList(): Observable<language[]> {
    return this.commonService.httpGet("", this.myAppUrl + '/SurveySection/GetLanguageList');
  }

  getAllSurveySectionLanguageList(sectionId: number): Observable<questionLanguageSetting[]> {
    return this.commonService.httpGet("", this.myAppUrl + '/SurveySection/GetAllQuestionLanguageSettings').pipe(
      map((data: questionLanguageSetting[]) => data.filter(x => x.entityId == sectionId))
    );
  }

  saveSurveySectionLanguageSettings(model: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.commonService.httpPost(this.myAppUrl + '/SurveySection/SaveQuestionOptionsLanguageSettings', model, httpOptions);
  }

  deleteSurveySectionLanguageMapping(questionId: number, mappingId: number): Observable<any> {
    const params = `?questionId=${questionId}&mappingId=${mappingId}`;
    return this.commonService.httpGet("", this.myAppUrl + '/SurveySection/DeleteQuestionOptionsLanguageDetails/' + params);
  }


}
